import { render, staticRenderFns } from "./bugIcon.vue?vue&type=template&id=0df07e23&"
import script from "./bugIcon.vue?vue&type=script&lang=js&"
export * from "./bugIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports